var _style, _g, _g2, _defs, _path, _ellipse, _defs2, _path2, _ellipse2, _defs3, _path3, _ellipse3, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuinoa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#FDD8B2;}\n\t.st2{fill:#FEEAD1;}\n\t.st3{clip-path:url(#XMLID_2_);fill:#E0B194;}\n\t.st4{clip-path:url(#XMLID_3_);fill:#E0B194;}\n\t.st5{clip-path:url(#XMLID_4_);fill:#E0B194;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 110.27,
    cy: 103.79,
    r: 15.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -45.1564 106.1435)",
    className: "st2",
    cx: 105.55,
    cy: 107.58,
    rx: 4.82,
    ry: 7.08
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000047773240058075320760000002085558522642422422_",
    cx: 69.26,
    cy: 106.11,
    r: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000047773240058075320760000002085558522642422422_",
    style: {
      overflow: "visible",
      fill: "#FDD8B2"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000047773240058075320760000002085558522642422422_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.94,100.7L66.94,100.7c-1.49,0.86-3.42,0.35-4.28-1.15l-2.55-4.42c-0.86-1.49-0.35-3.42,1.15-4.28h0 c1.49-0.86,3.42-0.35,4.28,1.15l2.55,4.42C68.95,97.91,68.43,99.84,66.94,100.7z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -58.8066 77.8261)",
    className: "st2",
    cx: 64.54,
    cy: 109.9,
    rx: 4.82,
    ry: 7.08
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000116916443965772847180000016838045097704439216_",
    cx: 143.78,
    cy: 128.46,
    r: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000116916443965772847180000016838045097704439216_",
    style: {
      overflow: "visible",
      fill: "#FDD8B2"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000116916443965772847180000016838045097704439216_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.6,127.61L149.6,127.61c-0.45-1.66,0.55-3.39,2.21-3.84l4.93-1.33c1.66-0.45,3.39,0.55,3.84,2.21v0 c0.45,1.66-0.55,3.39-2.21,3.84l-4.93,1.33C151.77,130.26,150.05,129.27,149.6,127.61z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8651 -0.5015 0.5015 0.8651 -42.5903 87.4567)",
    className: "st2",
    cx: 141.33,
    cy: 122.92,
    rx: 7.08,
    ry: 4.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000085224818275560132410000010612400396740695727_",
    cx: 94.78,
    cy: 140.37,
    r: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000085224818275560132410000010612400396740695727_",
    style: {
      overflow: "visible",
      fill: "#FDD8B2"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000085224818275560132410000010612400396740695727_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.34,134.7L96.34,134.7c-1.7-0.26-2.89-1.86-2.63-3.57l0.77-5.05c0.26-1.7,1.86-2.89,3.57-2.63h0 c1.7,0.26,2.89,1.86,2.63,3.57l-0.77,5.05C99.65,133.77,98.04,134.96,96.34,134.7z"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9938 -0.1112 0.1112 0.9938 -15.0622 10.7379)",
    className: "st2",
    cx: 88.72,
    cy: 140.39,
    rx: 4.82,
    ry: 7.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 87.9,
    cy: 70.52,
    r: 15.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3608 -0.9326 0.9326 0.3608 -10.4246 120.2575)",
    className: "st2",
    cx: 82.52,
    cy: 67.73,
    rx: 7.08,
    ry: 4.82
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.45,
    cy: 75.07,
    r: 15.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.054 -0.9985 0.9985 0.054 62.9115 204.5966)",
    className: "st2",
    cx: 139.43,
    cy: 69.1,
    rx: 4.82,
    ry: 7.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuinoa);
export default __webpack_public_path__ + "static/media/Quinoa.99d0ed12b442d5aea02911dbe850f1a9.svg";
export { ForwardRef as ReactComponent };